var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowitworks2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 58,
    viewBox: "0 0 63 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.305 2.09441C34.0737 -0.436794 37.9218 -0.0943142 39.2157 2.70947L62.0595 52.2094C63.348 55.0013 61.1357 58.1424 58.073 57.8698L4.00241 53.0574C0.939688 52.7848 -0.683019 49.3024 1.07822 46.7819L32.305 2.09441Z",
    fill: "#F3672C",
    fillOpacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowitworks2);
export default __webpack_public_path__ + "static/media/howitworks2.ad436cc65869b94cee91376fc63ac219.svg";
export { ForwardRef as ReactComponent };